export default __webpack_public_path__ + "static/media/33_A.0c7c02c3.svg";